import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { modal } from 'redux/modules/app'
import { apiBadges } from 'helpers/decorators/api'
import { get } from 'lodash'
import styles from './engagement-badge.styl'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import GroupBadgeOverviewModal from '../../modals/badges/GroupBadgeOverviewModal'
import uuid from 'uuid'
import { getBadgeIconImg } from '../../../helpers/badgeHelper'

const enhance = compose(
    apiBadges(
        {
          list: true,
          loadBadges: true
        },
        connect(null, { modal })
    )
)

class EngagementBadge extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    badges: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
    awardBadges: PropTypes.object.isRequired,
    badgesProgress: PropTypes.object.isRequired,
    award: PropTypes.object.isRequired,
    modal: PropTypes.func,
    isBadgesStrictModeEnabled: PropTypes.object.isRequired
  }

    constructor(props) {
        super(props)
        this.key = uuid.v1()
    }

    state = {
        badge: null
    }

    handleOpenBadgeOverview = badge => {
        this.setState(
            {
                badge
            },
            () => {
                this.props.modal(`group-badge-overview-modal-${this.key}`)
            }
        )
    }

  render() {
    const {
      data,
      badges,
      activity,
      awardBadges,
      badgesProgress,
      award,
      isBadgesStrictModeEnabled
    } = this.props

      const badgeIconImg = getBadgeIconImg(award, get(data, 'badge'), true)

      return (
        <div className={styles.badgeWrapper}>
            <div className={styles.badgeIcon}>
                <img src={`data:image/png;base64, ${badgeIconImg}`} />
            </div>
            <div className={styles.badgeDescriptionWrapper}>
                <h4>{get(data, 'badge.name.translationText')}</h4>
                <div className={styles.badgeLevel}><span>{get(data, 'badge.badgeLevel.translationText')}</span></div>
                <div className={styles.badgeDescription}><span>{get(data, 'badge.description')}</span></div>
                <div className={styles.info}>
                <Link onClick={() => this.handleOpenBadgeOverview(get(data, 'badge'))}>
                    <FormattedMessage  id='label.view_more' defaultMessage='more information'/>
                </Link></div>
            </div>
            <GroupBadgeOverviewModal
                modalId={`group-badge-overview-modal-${this.key}`}
                badge={this.state.badge}
                badges={badges}
                awardBadges={awardBadges}
                badgesProgress={badgesProgress && badgesProgress[get(this.state.badge, 'name.value')]}
                isBadgesStrictModeEnabled={isBadgesStrictModeEnabled}
                award={award}
                activity={activity}
            />
        </div>
    )
  }
}
export default enhance(EngagementBadge)
